export interface PersonaTheme {
  bgLight: string;
  border: string;
  text: string;
  badge: string;
  solidBg: string;
}

export const PERSONA_THEMES: Record<string, PersonaTheme> = {
  chief_of_staff: {
    bgLight: "bg-blue-50",
    border: "border-blue-200/80",
    text: "text-blue-600",
    badge: "bg-blue-100 text-blue-700",
    solidBg: "bg-blue-600 text-white",
  },
  lead_scout: {
    bgLight: "bg-rose-50",
    border: "border-rose-200/80",
    text: "text-rose-600",
    badge: "bg-rose-100 text-rose-700",
    solidBg: "bg-rose-600 text-white",
  },
  operations: {
    bgLight: "bg-amber-50",
    border: "border-amber-200/80",
    text: "text-amber-600",
    badge: "bg-amber-100 text-amber-700",
    solidBg: "bg-amber-600 text-white",
  },
  account_manager: {
    bgLight: "bg-emerald-50",
    border: "border-emerald-200/80",
    text: "text-emerald-600",
    badge: "bg-emerald-100 text-emerald-700",
    solidBg: "bg-emerald-600 text-white",
  },
  quality_control: {
    bgLight: "bg-purple-50",
    border: "border-purple-200/80",
    text: "text-purple-600",
    badge: "bg-purple-100 text-purple-700",
    solidBg: "bg-purple-600 text-white",
  },
  billing: {
    bgLight: "bg-cyan-50",
    border: "border-cyan-200/80",
    text: "text-cyan-600",
    badge: "bg-cyan-100 text-cyan-700",
    solidBg: "bg-cyan-600 text-white",
  },
  hr: {
    bgLight: "bg-pink-50",
    border: "border-pink-200/80",
    text: "text-pink-600",
    badge: "bg-pink-100 text-pink-700",
    solidBg: "bg-pink-600 text-white",
  },
};

export function getPersonaTheme(key?: string): PersonaTheme {
  if (!key || !PERSONA_THEMES[key]) {
    return PERSONA_THEMES.chief_of_staff;
  }
  return PERSONA_THEMES[key];
}

export function formatToolkitName(slug: string): string {
  const map: Record<string, string> = {
    googlecalendar: "Google Calendar",
    googlesheets: "Google Sheets",
    googlemaps: "Google Maps",
    googledrive: "Google Drive",
    agent_mail: "Agent Mail",
    gohighlevel: "GoHighLevel",
    quickbooks: "QuickBooks",
    tavily: "Tavily Search",
    hubspot: "HubSpot",
    salesforce: "Salesforce",
    apollo: "Apollo",
    clearbit: "Clearbit",
    zendesk: "Zendesk",
    typeform: "Typeform",
    airtable: "Airtable",
    jira: "Jira",
    xero: "Xero",
    stripe: "Stripe",
    gusto: "Gusto",
    notion: "Notion",
    linear: "Linear",
  };
  return map[slug.toLowerCase()] || slug.charAt(0).toUpperCase() + slug.slice(1).replace("_", " ");
}
